/* eslint-disable no-inner-declarations */
import logger from '../../../utils/src/logger';
export var prototypeAdditions;
(function (prototypeAdditions) {
    function __defineRegions() {
        this.__regions = {};
        for (var regionName in this.__regionDefinition) {
            var regionDefinition = this.__regionDefinition[regionName];
            if (regionDefinition.isDefault) {
                this.__defaultRegionName = regionName;
            }
            this.__regions[regionName] = {
                isDefault: regionDefinition.isDefault
            };
        }
        return this.__regions;
    }
    prototypeAdditions.__defineRegions = __defineRegions;
    function setRegion(regionName, node) {
        if (Object.keys(this.__regions).length === 0) {
            logger.error("Trying to set a region \"" + regionName + "\" on the component " +
                ("\"" + this.__componentName + "\" but it does not have regions"));
            return;
        }
        checkRegionName(this, regionName);
        this[regionName] = node; // onChange takes it from here
    }
    prototypeAdditions.setRegion = setRegion;
    /**
     * Sets the default region for a component.
     * This will only work if a component has a default region. Can
     * be used if a component is created in declarative style by
     * a wrapper without specifying an explicit region.
     */
    function setDefaultRegion(nodeOrString) {
        if (!this.__defaultRegionName) {
            logger.error("Trying to set a default region on the component " +
                ("\"" + this.__componentName + "\" but it does not have a default region"));
            return;
        }
        this.setRegion(this.__defaultRegionName, nodeOrString);
    }
    prototypeAdditions.setDefaultRegion = setDefaultRegion;
    function removeRegion(regionName) {
        this[regionName] = undefined; // onChange takes it from here
    }
    prototypeAdditions.removeRegion = removeRegion;
    function checkRegionName(component, regionName) {
        if (!component.__regions[regionName]) {
            logger.error('The component has no region called: ' + regionName);
        }
    }
    /**
     * The getRegion method is a getter for the content of the region.  It verifies that the
     * property name is really a region, but otherwise returns the same as the property
     * accessor (string, number or DOM node);
     */
    function getRegion(regionName, node) {
        checkRegionName(this, regionName);
        return this[regionName];
    }
    prototypeAdditions.getRegion = getRegion;
})(prototypeAdditions || (prototypeAdditions = {}));
export function isPrimitiveRegion(regionValue) {
    return !regionValue || typeof regionValue === 'string' || typeof regionValue === 'number';
}
export function extendComponent(customPrototype, definition) {
    customPrototype.__regionDefinition = definition.regions || {};
}
//# sourceMappingURL=RegionHandling.js.map